<script lang="ts">
  import type { CategoryPropConfig } from '../../modules/projects/project.interface';
  import { Switch } from 'svelte-materialify';

  export let value: boolean;
  export let categoryPropConfig: CategoryPropConfig;

  if (!value) {
    value = false;
  }
</script>

<div class="ip-boolean">
  <p>{categoryPropConfig.name}</p>

  <div class="ip-form">
    <span class="ip-bool false">False</span>
    <Switch color="success" bind:checked={value} inset
      ><span class="ip-bool">True</span></Switch
    >
  </div>
</div>

<style lang="scss">
  .ip-boolean {
    p {
      margin-top: 12px;
      margin-bottom: 8px;
    }
  }

  .ip-form {
    display: flex;
    align-items: center;

    .ip-bool {
      display: inline-block;
      font-size: 12px;
      margin-right: 16px;

      &.false {
        position: relative;
        top: -3px;
      }
    }
  }
</style>
